import React from 'react';
import ModalDialog, { ModalCloseHandler } from 'src/components/ModalDialog';
import { useForm } from 'src/components/Form';
import { getPlatformVersionFormFields } from '../formFields';
import { PlatformVersionItem } from '../types';

type Props = {
  title: string;
  item?: PlatformVersionItem;
  open: boolean;
  onSubmit: (values: PlatformVersionItem) => void;
  onClose: ModalCloseHandler;
  loading?: boolean;
};

function EditPlatformVersionModal({
  item,
  title,
  open,
  onSubmit,
  onClose,
  loading,
}: Props) {
  const fields = getPlatformVersionFormFields(!!item?.id);
  const [form, handleSubmit] = useForm({
    values: item,
    fields,
    onSubmit,
  });

  return (
    <ModalDialog
      open={open}
      title={title}
      onClose={onClose}
      onConfirm={handleSubmit}
      confirmBtnText="Save"
      loading={loading}
      maxWidth="xs"
      fullWidth
    >
      {form}
    </ModalDialog>
  );
}

export default EditPlatformVersionModal;
